const serviceProjects = {
    "app-development": {
        title: "App Development",
        heroText: "Elite Mobile & Web Engineering",
        description: "Transforming complex business logic into seamless, high-performance mobile and web applications with Ziffcode's precision engineering.",
        projects: [
            {
                id: "ad-1",
                title: "Ziff-Fintech Mobile Suite",
                client: "Global Finance Corp",
                description: "A secure, multi-currency wallet system featuring real-time biometric authentication and cross-border instant settlements.",
                tech: ["React Native", "Node.js", "AWS Lamba", "PostgreSQL"],
                result: "300% increase in user retention within Q1."
            },
            {
                id: "ad-2",
                title: "AgriTrack IoT Dashboard",
                client: "EcoFarm Solutions",
                description: "A comprehensive web portal for monitoring crop health through real-time satellite imaging and IoT sensor data.",
                tech: ["React.js", "Python", "MQTT", "Redis"],
                result: "25% reduction in irrigation costs for commercial farmers."
            }
        ]
    },
    "product-design-ui-ux": {
        title: "Product Design (UI/UX)",
        heroText: "Tactical Interface Excellence",
        description: "Crafting intuitive, high-conversion interfaces that blend tactical functionality with premium aesthetics.",
        projects: [
            {
                id: "ux-1",
                title: "Stellar eCommerce Redesign",
                client: "Stellar Retail",
                description: "A complete overhaul of the shopping journey focusing on micro-interactions and frictionless checkout pathways.",
                tech: ["Figma", "Adobe XD", "Framer Motion", "High-Contrast UI"],
                result: "45% boost in conversion rates."
            },
            {
                id: "ux-2",
                title: "LogiNext Admin Portal",
                client: "Logistics Pro",
                description: "Transforming complex logistics data into a tactical, high-visibility dashboard for operations managers.",
                tech: ["Design Systems", "User Personas", "A/B Testing"],
                result: "Reduced operator task-completion time by 15 mins."
            }
        ]
    },
    "data-science-and-analytics": {
        title: "Data Science and Analytics",
        heroText: "Predictive Intelligence Engines",
        description: "Turning raw data into strategic assets through advanced machine learning and predictive modeling.",
        projects: [
            {
                id: "ds-1",
                title: "Predictive Maintenance Engine",
                client: "AeroParts Limited",
                description: "Machine learning models to predict component failure in industrial assembly lines using vibration data.",
                tech: ["TensorFlow", "Pandas", "PySpark", "Scikit-Learn"],
                result: "Saved $1.2M in annual unplanned downtime costs."
            },
            {
                id: "ds-2",
                title: "Market Insight Sentiment Bot",
                client: "TrendMedia",
                description: "Real-time NLP analysis of social media trends to predict consumer shift toward sustainable products.",
                tech: ["NLP", "HuggingFace", "Python", "Elasticsearch"],
                result: "92% accuracy in predicting quarterly trend shifts."
            }
        ]
    },
    "digital-marketing": {
        title: "Digital Marketing",
        heroText: "Strategic Market Captivity",
        description: "Precision-targeted marketing campaigns that dominate search results and capture market high-ground.",
        projects: [
            {
                id: "dm-1",
                title: "Ziff-Brand Growth Initiative",
                client: "Local Innovators",
                description: "A multi-channel SEO and Content Strategy overhaul that captured national-level keyword dominance.",
                tech: ["SEO", "PPC", "Marketing Automation", "SEM"],
                result: "10x organic traffic growth over 8 months."
            }
        ]
    },
    "it-services": {
        title: "IT Services",
        heroText: "Robust Technical Infrastructure",
        description: "Scalable infrastructure and security architectures designed for the modern digital enterprise.",
        projects: [
            {
                id: "it-1",
                title: "Cloud Migration Architecture",
                client: "Legacy Insure",
                description: "Migrating on-premise legacy systems to a tactical, high-availability hybrid cloud environment.",
                tech: ["Azure", "Docker", "Kubernetes", "DevOps"],
                result: "99.99% uptime achieved across peak global seasons."
            }
        ]
    },
    "kids-coding": {
        title: "Kids Coding",
        heroText: "Nurturing Future Architects",
        description: "Building the next generation of software engineers through gamified, cognitive-heavy learning paths.",
        projects: [
            {
                id: "kc-1",
                title: "Ziff-Kids Gamified Portal",
                client: "Internal Research",
                description: "A logic-based adventure game that teaches primary school children basic Python and JavaScript syntax.",
                tech: ["Scratch", "Blockly", "React Game Engine"],
                result: "Successfully graduated over 100 kids since 2023."
            }
        ]
    }
};

export default serviceProjects;
